import { createService } from '@betty/toolkit/api';
import { DailyScratcherSchema } from './DailyScratcherService.schemas';

export default createService(
  {
    launchDailyScratcher: {
      method: 'POST',
      url: ({ id }: { id: number }) => `/rewards/${id}/launch`,
      responseSchema: DailyScratcherSchema,
    },
  },
  ({ userId }) => `/Players/${userId}`,
);
